module.exports = __webpack_public_path__ + "static/img/13004B_1_R_20201022_fit.d34c4d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13004B_1_R_20201022_fit.png
// module id = jh8v
// module chunks = 0